export const ADD_BUTTON_CLICKED = 'content-message-templates-add-new-button-clicked';
export const NEW_TEMPLATE_ADDED = 'content-message-templates-new-message-added';
export const NEW_TRANSLATION_ADDED = 'content-message-templates-translation-added';
export const NEW_TEMPLATE_STARTED = 'content-message-template-started';
export const NEW_TEMPLATE_SELECTED = 'content-message-template-selected';
export const NEW_TEMPLATE_SAVED = 'content-message-template-saved';
export const NEW_TEMPLATE_SENT = 'content-message-template-sent';
export const TEMPLATE_DUPLICATED = 'content-message-templates-message-duplicated';
export const TEMPLATE_DELETED = 'content-message-templates-message-deleted';
export const CACHE_RESTARTED = 'content-message-templates-cache-reset-button';
